const isQuillEmpty = str => {
  if (!str || (str.replace(/<(.|\n)*?>/g, '').trim().length === 0 && !str.includes('<img'))) {
    return true;
  } else {
    return false;
  }
};

export default isQuillEmpty;
